import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo2x from "../static/images/logo2x.png";

function Header() {
  const location = useLocation();
  const pathMatchRoute = (route) => {
    return route === location.pathname ? true : false;
  };
  //scrolling hide reveal header animation
  const [show, setShow] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const controlNavbar = () => {
    window.scrollY < lastScrollY ? setShow(false) : setShow(true);
    setLastScrollY(window.scrollY);
  };
  useEffect(() => {
    window.onscroll = () => controlNavbar();
    //cleaning function
    // window.removeEventListener("scroll", controlNavbar);
  }, [lastScrollY]);
  return (
    <div
      className={`bg-white lg:fixed  top-0 z-50 w-full ease-linear duration-100 ${
        show ? "lg:-translate-y-28  lg:opacity-0" : ""
      }`}
    >
      <header className={`container mx-auto h-20 md:h-24 lg:h-28 `}>
        <nav className="navi h-full flex justify-between items-center">
          <ul className="navi_list hidden lg:flex">
            <li>
              <Link
                to="/"
                className={`nav-link px-7 py-4 hover:bg-prime hover:text-white ease-linear ${
                  pathMatchRoute("/") ? "active_page" : ""
                }`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/portfolio"
                className={`nav-link px-7 py-4 hover:bg-prime hover:text-white ease-linear ${
                  pathMatchRoute("/portfolio") ? "active_page" : ""
                }`}
              >
                PORTFOLIO
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className={`nav-link px-7 py-4 hover:bg-prime hover:text-white ease-linear ${
                  pathMatchRoute("/services") ? "active_page" : ""
                }`}
              >
                SERVICES
              </Link>
            </li>
          </ul>
          <Link to="/" className="logo">
            <img src={logo2x} alt="logo" />
          </Link>
          <ul className="navi_list hidden lg:flex">
            <li>
              <Link
                to="/about"
                className={`nav-link px-7 py-4 hover:bg-prime hover:text-white ease-linear ${
                  pathMatchRoute("/about") ? "active_page" : ""
                }`}
              >
                ABOUT US
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`nav-link px-7 py-4 hover:bg-prime hover:text-white ease-linear ${
                  pathMatchRoute("/contact") ? "active_page" : ""
                }`}
              >
                CONTACT
              </Link>
            </li>
            <li>
              <Link
                to="/"
                className={`nav-link px-7 py-4 hover:bg-prime hover:text-white ease-linear ${
                  pathMatchRoute("/s") ? "active_page" : ""
                }`}
              >
                SEARCH
              </Link>
            </li>
          </ul>
          <ul className="nav-list flex lg:hidden">
            <Link
              to="/"
              className="p-1 text-3xl active:text-primeDark text-black"
            >
              <i className="fa-brands fa-square-facebook "></i>
            </Link>
            <Link
              to="/"
              className="p-1 text-3xl active:text-primeDark text-black"
            >
              <i className="fa-brands fa-square-instagram"></i>
            </Link>
          </ul>
        </nav>
      </header>
    </div>
  );
}

export default Header;
